module.exports = __webpack_public_path__ + "img/jypx-5.6d5ff44b.webp";